const helpscout = {
  ENPS: "615484d52b380503dfdf5e31",
  IMPORT_CSV: "6155c7042b380503dfdf64c2"
};

export default helpscout;
